<template>
  <div class="description-display-value">
    <div class="description-display-value__text">
      {{ modelValue }}
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: String,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.description-display-value {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;

  &__text {
    color: var(--Black, #1d1d1d);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: pre-wrap;
  }
}
</style>
